/**
 * Gift checks (cashier phase 4; `vouchers` in the code): how much of a sale one
 * takes money off. The API applies it (`couponOnOneUnit`); every screen words it
 * through `describeVoucherValue`, so the admin, the member and the till say the
 * same thing. See CLAUDE.md, Gift checks.
 */
export const VOUCHER_DISCOUNT_SCOPES = ['one_unit', 'every_unit'] as const;
export type VoucherDiscountScope = (typeof VOUCHER_DISCOUNT_SCOPES)[number];

/**
 * "One item free", "50% off one item", "₱20.00 off one item"; a gift check that
 * takes money off every item reads like a coupon ("10% off", "₱5.00 off each").
 * An unknown scope reads as one item, the column's default.
 */
export function describeVoucherValue(p: {
  discountType: 'percent' | 'amount';
  discountValue: string | number;
  discountScope?: string | null;
}): string {
  const n = Number(p.discountValue);
  const v = Number.isFinite(n) ? n : 0;
  if (p.discountScope === 'every_unit') {
    return p.discountType === 'percent' ? `${v}% off` : `₱${v.toFixed(2)} off each`;
  }
  if (p.discountType === 'percent') return v >= 100 ? 'One item free' : `${v}% off one item`;
  return `₱${v.toFixed(2)} off one item`;
}
